import formatDistanceToNowStrict from 'date-fns/formatDistanceToNowStrict';
import { TFunction } from 'i18next';

import { DateFormat, formatDateWithYear } from '@lyearn/core/utils/date/formatDate';

const DATE_OFFSET = 24 * 60 * 60 * 1000 * 7; // 7 days
export const getDateString = (t: TFunction, createdAt: string) => {
  const createdAtDate = new Date(createdAt).getTime();
  const currentDate = new Date().getTime();
  if (currentDate - createdAtDate > DATE_OFFSET) {
    return formatDateWithYear(createdAt, DateFormat.Date);
  }
  return t('Common:TimeStamp', { time: formatDistanceToNowStrict(createdAtDate) });
};
